/**
 * Tracker de reproducción: acumula entries en memoria y las envía al backend
 * cada N segundos o cuando el buffer pasa cierto tamaño.
 *
 * Resiliente a offline: si el server no responde, mantiene el buffer para
 * el próximo intento (con cap).
 */

import { api, type PlaybackEntry } from './api';

const FLUSH_INTERVAL_MS = 30_000;
const MAX_BUFFER = 200;

const buffer: PlaybackEntry[] = [];
let timer: ReturnType<typeof setInterval> | null = null;

export function startPlaybackTracker() {
  if (timer) return;
  timer = setInterval(() => {
    void flush();
  }, FLUSH_INTERVAL_MS);
}

export function stopPlaybackTracker() {
  if (timer) clearInterval(timer);
  timer = null;
  void flush();
}

export function recordPlayback(entry: PlaybackEntry) {
  buffer.push(entry);
  // Trim si el buffer crece demasiado (offline largo)
  if (buffer.length > MAX_BUFFER) {
    buffer.splice(0, buffer.length - MAX_BUFFER);
  }
}

async function flush() {
  if (buffer.length === 0) return;
  const snapshot = buffer.splice(0); // copia y vacía
  try {
    await api.ingestPlayback(snapshot);
  } catch (err) {
    // Re-encolar al frente si falla
    buffer.unshift(...snapshot.slice(0, MAX_BUFFER));
    // eslint-disable-next-line no-console
    console.warn('Playback ingest failed', err);
  }
}
